/**
 * Set on a request to tell {@link ErrorHandlerInterceptor} to skip its
 * default error handling (global dialog / navigation / data-layer report)
 * for that request only. Read and stripped via `checkRequestMetadata`,
 * mirroring `RevalidateInterceptor`'s `X-Skip-Revalidate-Error-Handling`.
 */
export const SKIP_ERROR_HANDLING_HEADER = 'X-Skip-Error-Handling';
